import { setRangeMin } from './helpers';

export const setConstructionYearMin = setRangeMin('house_year');
